// New Zealand regions as provided by admin
export const NZ_REGIONS = [
  'Northland',
  'Auckland',
  'Waikato',
  'Bay of Plenty',
  'Tairawhiti Gisborne',
  'Hawkes Bay',
  'Taranaki',
  'Manawatu Whanganui',
  'Wellington',
  'Tasman',
  'Nelson',
  'Marlborough',
  'West Coast',
  'Canterbury',
  'Otago',
  'Southland',
  'Area Outside Region',
  'Chatham Islands',
] as const

// New Zealand city and district councils mapped to their primary region
// Using official Māori spelling with macrons where applicable
export const NZ_COUNCILS: { name: string; region: string }[] = [
  // Northland
  { name: 'Far North District Council', region: 'Northland' },
  { name: 'Whangārei District Council', region: 'Northland' },
  { name: 'Kaipara District Council', region: 'Northland' },

  // Auckland
  { name: 'Auckland Council', region: 'Auckland' },

  // Waikato
  { name: 'Thames-Coromandel District Council', region: 'Waikato' },
  { name: 'Hauraki District Council', region: 'Waikato' },
  { name: 'Waikato District Council', region: 'Waikato' },
  { name: 'Matamata-Piako District Council', region: 'Waikato' },
  { name: 'Hamilton City Council', region: 'Waikato' },
  { name: 'Waipā District Council', region: 'Waikato' },
  { name: 'Ōtorohanga District Council', region: 'Waikato' },
  { name: 'South Waikato District Council', region: 'Waikato' },
  { name: 'Waitomo District Council', region: 'Waikato' },
  { name: 'Taupō District Council', region: 'Waikato' },

  // Bay of Plenty
  { name: 'Western Bay of Plenty District Council', region: 'Bay of Plenty' },
  { name: 'Tauranga City Council', region: 'Bay of Plenty' },
  { name: 'Rotorua District Council', region: 'Bay of Plenty' },
  { name: 'Whakatāne District Council', region: 'Bay of Plenty' },
  { name: 'Kawerau District Council', region: 'Bay of Plenty' },
  { name: 'Ōpōtiki District Council', region: 'Bay of Plenty' },

  // Tairawhiti Gisborne
  { name: 'Gisborne District Council', region: 'Tairawhiti Gisborne' },

  // Hawkes Bay
  { name: 'Wairoa District Council', region: 'Hawkes Bay' },
  { name: 'Hastings District Council', region: 'Hawkes Bay' },
  { name: 'Napier City Council', region: 'Hawkes Bay' },
  { name: 'Central Hawkes Bay District Council', region: 'Hawkes Bay' },

  // Taranaki
  { name: 'New Plymouth District Council', region: 'Taranaki' },
  { name: 'Stratford District Council', region: 'Taranaki' },
  { name: 'South Taranaki District Council', region: 'Taranaki' },

  // Manawatu Whanganui
  { name: 'Ruapehu District Council', region: 'Manawatu Whanganui' },
  { name: 'Whanganui District Council', region: 'Manawatu Whanganui' },
  { name: 'Rangitīkei District Council', region: 'Manawatu Whanganui' },
  { name: 'Manawatū District Council', region: 'Manawatu Whanganui' },
  { name: 'Palmerston North City Council', region: 'Manawatu Whanganui' },
  { name: 'Tararua District Council', region: 'Manawatu Whanganui' },
  { name: 'Horowhenua District Council', region: 'Manawatu Whanganui' },

  // Wellington
  { name: 'Kāpiti Coast District Council', region: 'Wellington' },
  { name: 'Porirua City Council', region: 'Wellington' },
  { name: 'Upper Hutt City Council', region: 'Wellington' },
  { name: 'Hutt City Council', region: 'Wellington' },
  { name: 'Wellington City Council', region: 'Wellington' },
  { name: 'Masterton District Council', region: 'Wellington' },
  { name: 'Carterton District Council', region: 'Wellington' },
  { name: 'South Wairarapa District Council', region: 'Wellington' },

  // Tasman
  { name: 'Tasman District Council', region: 'Tasman' },

  // Nelson
  { name: 'Nelson City Council', region: 'Nelson' },

  // Marlborough
  { name: 'Marlborough District Council', region: 'Marlborough' },

  // West Coast
  { name: 'Buller District Council', region: 'West Coast' },
  { name: 'Grey District Council', region: 'West Coast' },
  { name: 'Westland District Council', region: 'West Coast' },

  // Canterbury
  { name: 'Kaikōura District Council', region: 'Canterbury' },
  { name: 'Hurunui District Council', region: 'Canterbury' },
  { name: 'Waimakariri District Council', region: 'Canterbury' },
  { name: 'Christchurch City Council', region: 'Canterbury' },
  { name: 'Selwyn District Council', region: 'Canterbury' },
  { name: 'Ashburton District Council', region: 'Canterbury' },
  { name: 'Timaru District Council', region: 'Canterbury' },
  { name: 'Mackenzie District Council', region: 'Canterbury' },
  { name: 'Waimate District Council', region: 'Canterbury' },
  { name: 'Waitaki District Council', region: 'Canterbury' },

  // Otago
  { name: 'Central Otago District Council', region: 'Otago' },
  { name: 'Queenstown-Lakes District Council', region: 'Otago' },
  { name: 'Dunedin City Council', region: 'Otago' },
  { name: 'Clutha District Council', region: 'Otago' },

  // Southland
  { name: 'Southland District Council', region: 'Southland' },
  { name: 'Gore District Council', region: 'Southland' },
  { name: 'Invercargill City Council', region: 'Southland' },
]

// Helper to get councils for a specific region
export const getCouncilsForRegion = (region: string): string[] => {
  return NZ_COUNCILS.filter((c) => c.region === region).map((c) => c.name)
}

// Get all council names as a flat list
export const getAllCouncilNames = (): string[] => {
  return NZ_COUNCILS.map((c) => c.name)
}
